module.exports = __webpack_public_path__ + "static/CTI-stacked-bd7f426d1e627cf9495a75189002e8e7.svg";